import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useOidcAuth } from '@/integrations/oidc/AuthProvider'

export const Route = createFileRoute('/auth/callback')({
	component: AuthCallback,
})

function AuthCallback() {
	const auth = useOidcAuth()
	const navigate = useNavigate()

	useEffect(() => {
		if (auth.isLoading) return
		if (auth.error) {
			// biome-ignore lint/suspicious/noConsole: We want to log the authentication error for debugging purposes.
			console.error('Authentication error:', auth.error)
			return
		}
		const returnTo = sessionStorage.getItem('return_to') || '/'
		sessionStorage.removeItem('return_to')
		navigate({ to: returnTo, replace: true })
	}, [auth.error, auth.isLoading, navigate])

	return null
}
